<template>
  <div class="uni-detail__wrp">
    <subpage-header :city-icon="universityDetails ? universityDetails.icon : null">
<div slot="bread">
<ul itemscope itemtype="http://schema.org/BreadcrumbList">
<!-- <li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span class="mytitle"> / </span>
<span itemprop="name">yurtlarburada.com</span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="universityDetails.slug" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">{{ universityDetails.name}} Yakın Öğrenci Yurtları</span>
</a>
<meta itemprop="position" content="2" />
</li> -->
<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name"></span>yurtlarburada.com<span class="mytitle"> / </span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="uni_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name">{{ uni_name }} Yakın Öğrenci Yurtları</span>
</a>
<meta itemprop="position" content="2" />
</li>
</ul>
</div>
      <span slot="title" v-if="universityDetails">
        <span class="color-light-green">{{ universityDetails.name }} </span> Hakkında
      </span>
      <div class="city-text" slot="text">
        <span v-if="universityDetails" v-html="universityDetails.detail_spot"></span>
      </div>
<!--       <div class="subpage-header-inf" slot="numbers">
        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm-female.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="universityDetails">{{ universityDetails.universities_count }}</strong>
            <span>Kız Öğr. Yurdu</span>
          </div>
        </div>

        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm-male.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="universityDetails">{{ universityDetails.dorms_count }}</strong>
            <span>Erkek Öğr. Yurdu</span>
          </div>
        </div>
      </div> -->
      <v-link
        v-if="universityDetails"
        class="button--more color-white subpage-header__btn"
        :title="`${universityDetails.name} Yakın Öğrenci Yurtları`"
        icon="icon-arrow-long-right"
        icon-position="right"
        :to="{ name: 'University', params: { slug: universityDetails.slug }}"
        slot="button"
      />

      <div class="uni-detail__card" slot="right" v-if="universityDetails">
        <UniInfoCard
          :logo="universityDetails.logo"
          :website="universityDetails.website"
        />
      </div>
    </subpage-header>
    <div class="subpage__inner uni-detail__inner">
      <SubpageNav :links="links" class="DesktopTab" />
      <div class="mobileTab">
        <!-- <select-box :options="linkMobile" title="Girişimcilik"/> -->
        <v-select placeholder="Hakkında" :options="linkMobile" @onselect="selectCategory"/>
      </div>
      <transition name="fade-up">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/components/SubpageHeader'
import SubpageNav from '@/components/SubpageNav'
import UniInfoCard from '@/components/UniInfoCard'
import axios from 'axios'
import { mapGetters } from 'vuex'
import {
  GET_UNIVERSITY_DETAILS
} from '@/store/actions.type'
export default {
  name: 'UniDetail',
  components: {
    SubpageHeader, SubpageNav, UniInfoCard
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.universityDetails ? this.universityDetails.detail_title : '',
      meta: [
        { name: 'description', content: this.universityDetails ? this.universityDetails.detail_description : '' },
        { name: 'keywords', content: this.universityDetails ? this.universityDetails.detail_keywords : '' }
      ],
      link: [
        { rel: 'canonical', href: this.url }
      ]
    }
  },
  data () {
    return {
      fullPath: '',
      url: '',
      uni_url: '',
      uni_name: '',
      myslug: null,
      selectedTab: {
        name: 'Hakkında',
        slug: '/hakkinda'
      },
      links: [
        {
          id: 0,
          title: 'Hakkında',
          to: { name: 'UniDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.slug } }
        },
        {
          id: 1,
          title: 'Fakülteler',
          to: { name: 'UniDetailFaculty' }
        }
        /* {
          id: 2,
          title: 'Kampüste Yaşam',
          to: { name: 'UniDetailCampus' }
        },
        {
          id: 3,
          title: 'Soru Cevap',
          to: { name: 'UniQuestionsAnswer' }
        } */
      ],
      linkMobile: [
        {
          name: 'Hakkında'
        },
        {
          name: 'Fakülteler'
        } /* ,
        {
          name: 'Kampüste Yaşam'
        },
        {
          name: 'Soru-Cevap'
        } */
      ]
    }
  },
  methods: {
    selectCategory (opt) {
      if (opt.name === 'Fakülteler') {
        this.$router.push('fakulteler')
      } else {
        this.$router.push({ name: 'UniDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.slug } })
      }
    },
    checkTab () {
      let slug = this.$route.params.slug.split('/')
      if (this.$route.path.includes('fakulteler')) {
        this.selectedTab.name = 'Fakülteler'
        this.selectedTab.slug = slug[0] + slug[1] + '/fakulteler'
      } else {
        this.selectedTab.name = 'Hakkında'
        this.selectedTab.slug = slug[0] + slug[1] + '/fakulteler'
      }
    },
    checkUniDetails () {
      const slug = this.$route.params.slug
      // console.log(slug)
      if (this.universityDetails) {
        if (this.universityDetails.slug !== slug) {
          this.$store.dispatch(GET_UNIVERSITY_DETAILS, null)
          this.getUniDetails()
        }
      } else {
        this.getUniDetails()
      }
    },
    getUniDetails () {
      let self = this
      axios.get(`/site/universities/detail/${self.$route.params.slug}`)
        .then(response => {
          self.$store.dispatch(GET_UNIVERSITY_DETAILS, response.data)
          self.uni_url = '/' + response.data.slug + '-yakin-ogrenci-yurtlari/'
          self.uni_name = response.data.name
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['universityDetails'])
  },
  mounted () {
    // this.checkUniDetails()
    this.getUniDetails()
  },
  created () {
    this.checkUniDetails()
    this.getUniDetails()
    this.url = window.location.origin + this.$route.fullPath
    this.fullPath = this.$route.fullPath
  },
  watch: {
    $route () {
      this.checkTab()
      this.checkUniDetails()
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/components/uni-detail";
  .mytitle {
    font-size: 15px;
    color:white;
  }
</style>
